define.alias("shared/components/shared/mavely/logo-badge", "media/components/shared/mavely/logo-badge");